module.exports = __webpack_public_path__ + "img/r661.3371964c.jpg";